"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// all keys stored in the cache by this SDK will be prefixed with this value
var CACHE_PREFIX = 'branding:'; // cached for 1 minute

var CACHE_DURATION_MIN = 1;

function SDK(baseUrl, fetch, cacheInterface, companyId) {
  function _fetchJson(url, options) {
    return new Promise(function ($return, $error) {
      var res, data, text;

      if (options && options.body) {
        options.headers = _objectSpread(_objectSpread({}, options.headers || {}), {}, _defineProperty({}, 'Content-Type', 'application/json'));
      }

      return Promise.resolve(fetch("".concat(baseUrl).concat(url), options)).then(function ($await_3) {
        try {
          res = $await_3;

          if (res.ok) {
            return Promise.resolve(res.json()).then($return, $error);
          }

          if (res.headers.get('Content-Type').indexOf('application/json') !== -1) {
            return Promise.resolve(res.json()).then(function ($await_5) {
              try {
                data = $await_5;
                return $error(_objectSpread({
                  status: res.status
                }, data));
              } catch ($boundEx) {
                return $error($boundEx);
              }
            }, $error);
          }

          function $If_2() {
            return Promise.resolve(res.text()).then(function ($await_6) {
              try {
                text = $await_6;
                return $error(text);
              } catch ($boundEx) {
                return $error($boundEx);
              }
            }, $error);
          }

          return Promise.resolve(res.text()).then(function ($await_6) {
            try {
              text = $await_6;
              return $error(text);
            } catch ($boundEx) {
              return $error($boundEx);
            }
          }, $error);
        } catch ($boundEx) {
          return $error($boundEx);
        }
      }.bind(this), $error);
    });
  }

  var getKey = function getKey(key) {
    if (companyId) {
      return "".concat(CACHE_PREFIX).concat(companyId, ":").concat(key);
    }

    return "".concat(CACHE_PREFIX).concat(key);
  };

  var _cacheGet = function _cacheGet(key) {
    return cacheInterface.get(getKey(key));
  };

  var _cacheSet = function _cacheSet(key, value, ttl) {
    return cacheInterface.set(getKey(key), value, ttl);
  };

  var _cacheClear = function _cacheClear() {
    return cacheInterface.clear();
  };

  return {
    getColors: function getColors() {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var options, key, cached, response;
        options = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
        key = "colors-".concat(JSON.stringify(options));
        cached = _cacheGet(key);

        if (cached) {
          return $return(cached);
        }

        return Promise.resolve(_fetchJson('/colors', {
          method: 'POST',
          body: JSON.stringify(options)
        })).then(function ($await_7) {
          try {
            response = $await_7;
            return $return(_cacheSet(key, response, CACHE_DURATION_MIN));
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    },
    upsertColors: function upsertColors(colors) {
      return new Promise(function ($return, $error) {
        var response;
        return Promise.resolve(_fetchJson('/colors', {
          method: 'PUT',
          body: JSON.stringify({
            colors: colors
          })
        })).then(function ($await_8) {
          try {
            response = $await_8;

            _cacheClear();

            return $return(response);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    },
    getElements: function getElements() {
      return new Promise(function ($return, $error) {
        var key, cached, response;
        key = 'elements';
        cached = _cacheGet(key);

        if (cached) {
          return $return(cached);
        }

        return Promise.resolve(_fetchJson('/elements')).then(function ($await_9) {
          try {
            response = $await_9;
            return $return(_cacheSet(key, response, CACHE_DURATION_MIN));
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    },
    getProperties: function getProperties() {
      return new Promise(function ($return, $error) {
        var key, cached, response;
        key = 'properties';
        cached = _cacheGet(key);

        if (cached) {
          return $return(cached);
        }

        return Promise.resolve(_fetchJson('/properties')).then(function ($await_10) {
          try {
            response = $await_10;
            return $return(_cacheSet(key, response, CACHE_DURATION_MIN));
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    },
    getElementProperties: function getElementProperties() {
      return new Promise(function ($return, $error) {
        var key, cached, response;
        key = 'element-properties';
        cached = _cacheGet(key);

        if (cached) {
          return $return(cached);
        }

        return Promise.resolve(_fetchJson('/element-properties')).then(function ($await_11) {
          try {
            response = $await_11;
            return $return(_cacheSet(key, response, CACHE_DURATION_MIN));
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    },
    getStyles: function getStyles() {
      var $args = arguments;
      return new Promise(function ($return, $error) {
        var options, key, cached, response;
        options = $args.length > 0 && $args[0] !== undefined ? $args[0] : {};
        key = "styles-".concat(JSON.stringify(options));
        cached = _cacheGet(key);

        if (cached) {
          return $return(cached);
        }

        return Promise.resolve(_fetchJson('/styles', {
          method: 'POST',
          body: JSON.stringify(options)
        })).then(function ($await_12) {
          try {
            response = $await_12;
            return $return(_cacheSet(key, response, CACHE_DURATION_MIN));
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    },
    upsertStyles: function upsertStyles(styles) {
      return new Promise(function ($return, $error) {
        var response;
        return Promise.resolve(_fetchJson('/styles', {
          method: 'PUT',
          body: JSON.stringify({
            styles: styles
          })
        })).then(function ($await_13) {
          try {
            response = $await_13;

            _cacheClear();

            return $return(response);
          } catch ($boundEx) {
            return $error($boundEx);
          }
        }, $error);
      });
    }
  };
}

var noCache = {
  get: function get() {
    return undefined;
  },
  set: function set(key, value, lifetimeMins) {
    return value;
  },
  clear: function clear() {
    return undefined;
  }
};

module.exports = function (url, customFetch) {
  var cacheInterface = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noCache;
  var companyId = arguments.length > 3 ? arguments[3] : undefined;

  if (typeof customFetch !== 'function') {
    throw new Error("".concat(_typeof(customFetch), " is not a function"));
  }

  return new SDK(url, customFetch, cacheInterface, companyId);
};
//# sourceMappingURL=index.js.map